import React from "react";
import CustomIcon from "../../assets/images/Custom Icon (1).svg";
import Pattern from "../../assets/images/Pattern.svg";
import mail from "../../assets/images/mail-line.svg";
import mailerror from "../../assets/images/mail-line (1).svg";
import check from "../../assets/images/check-line.svg";
import error from "../../assets/images/close-circle-line.svg";
import Group from "../../assets/images/Header (1).svg";
import CustomInput from "../../components/common/InputField/InputField";
import globe from "../../assets/icons/global.svg";
import pic from "../../assets/icons/2024.svg";
import lock from "../../assets/icons/lock-2-line.svg";
import eye from "../../assets/icons/eye-line.svg";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./SetNewPassword.css";
import apiService from "../../services/apiService";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const SetNewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Use URLSearchParams to extract query parameters
  const queryParams = new URLSearchParams(location.search);

  const token = queryParams.get("token");
  const email = queryParams.get("email");
  const [language, setLanguage] = React.useState("en");
  const [passwordType, setPasswordType] = React.useState("password");
  const [confirmPasswordType, setConfirmPasswordType] =
    React.useState("password");
  const [isPasswordValid, setIsPasswordValid] = React.useState({
    uppercase: false,
    lowercase: false,
    digit: false,
    specialChar: false,
  });
  let isRtl = language === "ar";

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    setLanguage(selectedLanguage);
  };

  const handleRegisterClick = () => {
    // Navigate to the registration page (change the path to your desired route)
    navigate("/");
  };

  const validatePassword = (password) => {
    setIsPasswordValid({
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /\d/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const formik = useFormik({
    initialValues: {
      newPassword: "", // Initial value for the new password field
      confirmPassword: "", // Initial value for the confirm password field
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Please enter a new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your password"),
    }),
    onSubmit: async (values) => {
      // Handle form submission

      try {
        const response = await apiService.post("resetPassword", {
          password: values.newPassword,
          email: email,
          token: token,
        });
        toast.success(response.message, { toastId: "9o9" });
        setTimeout(() => {
          navigate("/");
        }, 2000);
        if (response) {
        }
      } catch (e) {
        console.log(e);
        toast.error(e.message, { toastId: "9p9" });
      }
    },
  });

  const togglePasswordVisibility = () => {
    setPasswordType((prevType) =>
      prevType === "password" ? "text" : "password"
    );
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordType((prevType) =>
      prevType === "password" ? "text" : "password"
    );
  };

  return (
    <div>
      <section
        className="bg-[#F6F8FA] "
        style={{ backgroundImage: `url(${Pattern})` }}
      >
        <div className="p-12">
          <img src={Group} alt="logo" />
        </div>

        <div
          className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0"
          dir={isRtl ? "rtl" : "ltr"}
        >
          <div className="w-full h-[740px]  p-6 bg-white rounded-[24px] shadow  md:mt-0 sm:max-w-md   sm:p-8">
            <div className="flex flex-col items-center text-center justify-center pb-6">
              <div style={{ paddingBottom: "15px" }}>
                <img src={CustomIcon} alt="logo" className="mb-15" />
              </div>
              <h2 className="title-h5 mb-1 text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">
                Set New Password
              </h2>
              <p className="paragraph-small">
                Create your new password and confirm it below to ensure they
                match.
              </p>
            </div>
            <div className="pb-0">
              <hr />
            </div>
            <form
              className="mt-4 space-y-4 lg:mt-5 md:space-y-5"
              onSubmit={formik.handleSubmit}
            >
              {/* New Password Input */}
              <div>
                <CustomInput
                  type={passwordType}
                  SecondIcon={
                    <img
                      src={eye}
                      alt="logo"
                      onClick={togglePasswordVisibility}
                    />
                  }
                  Secondposition="right-4"
                  icon={<img src={lock} alt="logo" />}
                  position="left-4"
                  labelClass="label-class"
                  isRequiredClass="text-[#2D9F75]"
                  isRequired={true}
                  value={formik.values.newPassword}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                    validatePassword(e.target.value);
                  }}
                  name="newPassword"
                  label="New Password"
                  className={`border ${
                    !(formik.touched.newPassword && formik.errors.newPassword)
                      ? "border-gray-300"
                      : "border-[red]"
                  } text-gray-800 bg-white focus:bg-transparent rounded-[12px] focus:outline-none px-5  py-3.5 input-with-icon`}
                  height="h-[40px]"
                />
                {formik.touched.newPassword && formik.errors.newPassword ? (
                  <div className="flex">
                    <div className="mt-2 pr-2">
                      <img src={error} alt="logo" />{" "}
                    </div>
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.newPassword}
                    </div>
                  </div>
                ) : null}
              </div>

              {/* Confirm Password Input */}
              <div>
                <CustomInput
                  type={confirmPasswordType}
                  SecondIcon={
                    <div onClick={toggleConfirmPasswordVisibility}>
                      <img src={eye} alt="logo" />
                    </div>
                  }
                  Secondposition="right-4"
                  icon={<img src={lock} alt="logo" />}
                  position="left-4"
                  labelClass="label-class"
                  isRequiredClass="text-[#2D9F75]"
                  isRequired={true}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="confirmPassword"
                  label="Confirm Password"
                  className={`border ${
                    !(
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    )
                      ? "border-gray-300"
                      : "border-[red]"
                  } text-gray-800 bg-white focus:bg-transparent rounded-[12px] focus:outline-none px-5 py-3.5 input-with-icon`}
                  height="h-[40px]"
                />
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <div className="flex">
                    <div className="mt-2 pr-2">
                      <img src={error} alt="logo" />{" "}
                    </div>
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.confirmPassword}
                    </div>
                  </div>
                ) : null}
              </div>

              <button
                type="submit"
                className="w-full text-[white] bg-[#007A63] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  :bg-primary-700 :ring-primary-800"
              >
                Update Password
              </button>
            </form>
            <div className="pt-8">
              <div className="flex">
                <div className="mt-1 pr-2">
                  {isPasswordValid.uppercase ? (
                    <img src={check} alt="logo" />
                  ) : (
                    <img src={error} alt="logo" />
                  )}
                </div>
                <div className="text-[#525866] text-sm mt-1 paragraph-small-error">
                  {" "}
                  Must include at least one uppercase letter (A-Z).
                </div>
              </div>
              <div className="flex pt-2">
                <div className="mt-1 pr-2">
                  {isPasswordValid.lowercase ? (
                    <img src={check} alt="logo" />
                  ) : (
                    <img src={error} alt="logo" />
                  )}{" "}
                </div>
                <div className="text-[#525866] text-sm mt-1 paragraph-small-error">
                  {" "}
                  Must include at least one lowercase letter (a-z).
                </div>
              </div>
              <div className="flex pt-2">
                <div className="mt-1 pr-2">
                  {isPasswordValid.digit ? (
                    <img src={check} alt="logo" />
                  ) : (
                    <img src={error} alt="logo" />
                  )}
                </div>
                <div className="text-[#525866] text-sm mt-1 paragraph-small-error">
                  {" "}
                  Must include at least one digit (0-9).
                </div>
              </div>
              <div className="flex pt-2">
                <div className="mt-1 pr-2">
                  {isPasswordValid.specialChar ? (
                    <img src={check} alt="logo" />
                  ) : (
                    <img src={error} alt="logo" />
                  )}{" "}
                </div>
                <div className="text-[#525866] text-sm mt-1 paragraph-small-error">
                  {" "}
                  Must include at least one special character (e.g., !, @, #, $,
                  %, ^, &, *).
                </div>
              </div>
            </div>
          </div>

          <div className="mt-14">
            <span className="paragraph-small">Changed your mind?</span>
            <span
              className="text-styled-underline"
              style={{ cursor: "pointer" }}
              onClick={() => handleRegisterClick()}
            >
              {" "}
              Go Back{" "}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between p-12">
          <div
            style={{ fontFamily: "inter" }}
            className="font-[400] text-[#525866] text-sm"
          >
            <img src={pic} alt="logo" />
          </div>
          <form className="flex items-center">
            <img src={globe} alt="logo" />
            <select
              id="countries_disabled"
              value={language}
              onChange={handleLanguageChange}
              style={{ fontFamily: "inter" }}
              className="custom-dropdown bg-[#F6F8FA] border-[#F6F8FA] font-[400] text-[#525866] text-sm rounded-lg focus:ring-[white] focus:border-[white] block w-[76px] p-2.5 "
            >
              <option value="en">ENG</option>
              <option value="ar">AR</option>
            </select>
          </form>
        </div>
      </section>
    </div>
  );
};

export default SetNewPassword;
